import React from 'react';
import { Camera, ExternalLink, Image } from 'lucide-react';

const Photos = () => {
  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-4 animate-fade-in">📸 Trip Photos</h2>
      
      {/* Placeholder for Google Photos Integration */}
      <div className="bg-white/95 dark:bg-gray-800/95 backdrop-blur rounded-xl shadow-lg p-5 border border-orange-100 dark:border-gray-700 animate-on-scroll card-hover hover-lift">
        <div className="text-center py-12">
          <Camera className="w-16 h-16 mx-auto text-gray-400 mb-4" />
          <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-300 mb-2">Google Photos Album</h3>
          <p className="text-gray-600 dark:text-gray-400 mb-6 max-w-md mx-auto">
            Share your Cape San Blas memories! Connect your Google Photos album to display trip photos here.
          </p>
          
          {/* Placeholder buttons */}
          <div className="space-y-3">
            <button 
              className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors ripple button-press"
              onClick={() => alert('Google Photos integration coming soon!')}
            >
              <Image className="w-5 h-5" />
              Connect Google Photos
            </button>
            
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Album link will be shared closer to the trip
            </p>
          </div>
        </div>
      </div>
      
      {/* Feature preview */}
      <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4 border border-blue-200 dark:border-blue-800">
        <h4 className="font-medium text-blue-800 dark:text-blue-200 mb-2 flex items-center gap-2">
          <Camera className="w-4 h-4" />
          Coming Features:
        </h4>
        <ul className="text-sm text-blue-700 dark:text-blue-300 space-y-1 ml-6">
          <li>• View shared trip photos in a beautiful gallery</li>
          <li>• Upload your own photos to the shared album</li>
          <li>• Browse photos by day or location</li>
          <li>• Download all photos at the end of the trip</li>
        </ul>
      </div>
      
      {/* Temporary link placeholder */}
      <div className="text-center">
        <a 
          href="#"
          onClick={(e) => {
            e.preventDefault();
            alert('Album link will be available soon!');
          }}
          className="inline-flex items-center gap-2 text-blue-600 dark:text-blue-400 hover:underline"
        >
          <ExternalLink className="w-4 h-4" />
          View Google Photos Album
        </a>
      </div>
    </div>
  );
};

export default Photos;